// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m3-c";
export var backButton = "_m3-4";
export var backIcon = "_m3-5";
export var chevronShortcut = "_m3-6";
export var container = "_m3-1";
export var editor = "_m3-8";
export var editorWrapper = "_m3-7";
export var prefix = "_m3-2";
export var searchIcon = "_m3-3";
export var suffix = "_m3-9";
export var suffixContent = "_m3-a";
export var suffixText = "_m3-b";
export var wrapper = "_m3-0";